import { AppRoutes } from "./AppRoutes";

export enum DutyScheduleRoutes {
  ById = ":id",
}

/** The three tabs of the duty schedule detail page. */
export enum DutyScheduleTab {
  DataEntry = "data-entry",
  CounselorOverview = "counselor-overview",
  Distribution = "distribution",
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type DutyScheduleByIdParams = {
  id: string;
};

export type DutyScheduleTabParams = DutyScheduleByIdParams & {
  tab: DutyScheduleTab;
};

export const dutySchedulePath = {
  byId: (params: DutyScheduleByIdParams) => `${AppRoutes.DutySchedule}/${params.id}`,
  byTab: (params: DutyScheduleTabParams) => `${AppRoutes.DutySchedule}/${params.id}/${params.tab}`,
};
